import { withChartLayout } from 'components/common';
import IntegumentaryInterventions from 'components/features/chart/system-nursing-interventions/integumentary-interventions/IntegumentaryInterventions';

const IntegumentaryInterventionsPage = withChartLayout('Integumentary Interventions')(IntegumentaryInterventions);
export default IntegumentaryInterventionsPage;
